module.exports = __webpack_public_path__ + "static/img/netWork.a72672b8.png";